export function Security() {
  const securityFeatures = [
    {
      title: 'No-Logs Policy',
      description: 'We never track, collect, or store your online activities or personal data',
      icon: 'ri-file-forbid-line'
    },
    {
      title: 'Kill Switch',
      description: 'Automatically disconnects your internet if VPN connection drops',
      icon: 'ri-shut-down-line'
    },
    {
      title: 'DNS Leak Protection',
      description: 'Prevents DNS requests from being exposed to your ISP',
      icon: 'ri-shield-line'
    },
    {
      title: 'Split Tunneling',
      description: 'Choose which apps use VPN and which use regular connection',
      icon: 'ri-route-line'
    }
  ];

  return (
    <section id="security" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-teal-100 px-4 py-2 rounded-full mb-6">
              <i className="ri-lock-line text-teal-600"></i>
              <span className="text-teal-900 text-sm font-semibold">Maximum Security</span>
            </div>
            
            <h3 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Your Privacy is Our Priority
            </h3>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              We implement industry-leading security protocols and privacy measures to ensure your data remains completely protected and confidential at all times.
            </p>

            <div className="space-y-6">
              {securityFeatures.map((feature, index) => (
                <div key={index} className="flex gap-4 items-start">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-xl flex-shrink-0">
                    <i className={`${feature.icon} text-teal-600 text-xl`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-1">
                      {feature.title}
                    </h4>
                    <p className="text-gray-600">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 p-6 bg-gradient-to-r from-teal-50 to-teal-100 rounded-2xl border border-teal-200">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-full flex-shrink-0">
                  <i className="ri-information-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-bold text-gray-900 mb-2">Certified Security Standards</h4>
                  <p className="text-gray-700 text-sm leading-relaxed">
                    Our VPN infrastructure meets international security standards and undergoes regular third-party security audits to ensure the highest level of protection for our users.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/4ff43bdaab922854c2da0c471094d7c3.jpg"
                alt="VPN Security Protection"
                className="w-full h-auto object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-teal-900/20 to-transparent"></div>
            </div>
            
            <div className="absolute -bottom-6 -left-6 bg-white p-6 rounded-2xl shadow-xl border border-gray-100">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 flex items-center justify-center bg-green-100 rounded-full">
                  <i className="ri-checkbox-circle-fill text-green-600 text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Secure Connection</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
